import { NgModule } from "@angular/core";
import { CommonModule } from "common";
import { SharedModule } from "../shared/shared.module";
import { UpdatePasswordRoutingModule } from "./update-password-routing.module";
import { UpdatePasswordComponent } from "./update-password.component";

@NgModule({
  imports: [CommonModule, UpdatePasswordRoutingModule, SharedModule],
  declarations: [UpdatePasswordComponent],
})
export class UpdatePasswordModule {}
